/*
 * @Author: 317473294@qq.com
 * @Date: 2023-10-29 10:11:14
 * @LastEditTime: 2023-10-29 12:25:58
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/utils/priButton.js
 */
import Vue from 'vue'
Vue.directive('permission', {  
    inserted: function (el, binding, vnode) {  
      const btnValue = binding.value; // 获取指令绑定的值，即角色名称  
      if (!btnValue) {  
        // 如果未指定角色，则按钮不可点击  
        el.disabled = true;  
      } else {  
        // 检查当前用户是否有权限点击按钮  
        const hasPermission = vnode.context.$store.state.permissions.includes(btnValue);  
        if (!hasPermission) {  
          // 如果用户没有权限，则按钮不可点击  
             el.disabled = true;  
             el.style.cursor="not-allowed"
        } else {  
          // 如果用户有权限，则按钮可点击  
          el.disabled = false;  
        }  
      };
    //   el.addEventListener('click',function(){
    //     const hasPermission = vnode.context.$store.state.permissions.includes(btnValue);  
    //     if (!hasPermission) {  
    //         vnode.context.premBtn=true
    //         // alert("您权限不足，请联系管理员")
    //     }
    //   },this)

      //
    //   el.addEventListener('mousemove',function(){
    //     const hasPermission = vnode.context.$store.state.permissions.includes(btnValue);  
    //     if (!hasPermission) {  
    //         vnode.context.premBtn=true
    //         // alert("您权限不足，请联系管理员")
    //     }
    //   },this)
    }  
  });
  export default Vue.directive('permission');


// WEBPACK FOOTER //
// ./src/utils/priButton.js